import React from 'react'
import '../../styles/Rules.less'

const Privacy = () => (
     <div style={{textAlign: 'left', padding: 10}}>
     <p>This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.</p>
<h1>
What personal information do we collect from the people that visit our blog, website or app?
</h1>
<p>
When ordering or registering on our site, as appropriate, you may be asked to enter your name and email address.
</p>
<p>
If you sign up using your Facebook account, we will also collect your Facebook Profile URL in order to enable other users to connect with you (you can turn this on or off through your profile).
</p>
<h1>
When do we collect information?
</h1>

<p>
We collect information from you when you register on our site.
</p>
<h1>
How do we use your information?
</h1>
 
<p>
We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:
</p>
<ul>
<li>To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.</li>
<li>To send periodic emails regarding your order or other products and services.</li>
</ul>
<h1>
How do we protect your information?
</h1>
<p>
Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.
</p>
<p>
We use regular Malware Scanning.
</p>
<p>
Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology.
</p>
<p>
We implement a variety of security measures when a user enters, submits, or accesses their information to maintain the safety of your personal information.
</p>
<p>
All transactions are processed through a gateway provider and are not stored or processed on our servers.
</p>
<h1>How do I request deleting my information from your site?</h1>
<p>
Contact our <a href="mailto:feedback@stakehousesports.com">Feedback Team</a> and we will confirm within 7 business days that your information has been deleted.
</p>
<h1>
Do we use 'cookies'?
</h1>
<p>
Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.
</p>
<p>
We use cookies to:
</p>
<ul>
<li>Understand and save user's preferences for future visits.</li>
</ul>
<p>
You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.
</p>
<p>
If you turn cookies off, it won't affect the user's experience .
</p>
<h1>Third-party disclosure</h1>
<p>
We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.
</p>
<h2>
Third-party links
</h2>
<p>
Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.
</p>
<p>
Google
</p>
<p>
Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. https://support.google.com/adwordspolicy/answer/1316548?hl=en
</p>
<p>
We use Google AdSense Advertising on our website.
</p>
<p>
Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.
</p>
<p>
We have implemented the following:
</p>
<p>
We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.
</p>
<p>
<strong>Opting out:</strong><br/>
Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.
</p>
<h1>
COPPA (Children Online Privacy Protection Act)
</h1>
<p>
When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online.
</p>
<p>
We do not specifically market to children under the age of 13 years old.
</p>
<p>
  We do NOT let third-parties, including ad networks or plug-ins collect PII from children under 13.
</p>
<h1>
Fair Information Practices
</h1>
<p>
The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information.
</p>
<p>
In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:
</p>
<ul>
  <li>We will notify you via email within 7 business days</li>
</ul>
<p>
We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.
</p>
<h1>
CAN SPAM Act
</h1>
<p>
The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.
</p>
<p>
We collect your email address in order to:
</p>
<ul>
  <li>Send information, respond to inquiries, and/or other requests or questions</li>
<li>Process orders and to send information and updates pertaining to orders.</li>
<li>Send you additional information related to your product and/or service</li>
<li>Market to our mailing list or continue to send emails to our clients after the original transaction has occurred.</li>
</ul>
<p>
To be in accordance with CANSPAM, we agree to the following:
</p>
<ul>
<li>Not use false or misleading subjects or email addresses.</li>
<li>Identify the message as an advertisement in some reasonable way.</li>
<li>Include the physical address of our business or site headquarters.</li>
<li>Monitor third-party email marketing services for compliance, if one is used.</li>
<li>Honor opt-out/unsubscribe requests quickly.</li>
<li>Allow users to unsubscribe by using the link at the bottom of each email.</li>
</ul>
<p>
If at any time you would like to unsubscribe from receiving future emails, you can email our <a href="mailto:feedback@stakehousesports.com">Feedback Team</a>.
</p>
<ul><li>Follow the instructions at the bottom of each email and we will promptly remove you from ALL correspondence.</li></ul>

<h1>
Contacting Us
</h1>
<p>
If there are any questions regarding this privacy policy, you may contact us using the information below.
</p>
<p>
crowdsourcedscores.com<br/>
600 4th Ave<br/>
Seattle, WA 98104<br/>
USA<br/>
<a href="mailto:feedback@stakehousesports.com">feedback@stakehousesports.com</a>
</p>
<p>
Last Edited on 2021-09-07
</p>
</div>)

 export default Privacy
